import { type ReactNode } from 'react';
import { ActionIcon, Flex, Title, type FlexProps } from '@mantine/core';
import { IconArrowLeft } from '@tabler/icons-react';
import classes from './PageContainer.module.scss';
import { useNavigate } from 'react-router';

type PageContainerProps = {
  children: ReactNode;
  title: string;
  actionButton?: ReactNode;
  className?: string;
  canGoBack?: boolean;
} & FlexProps;

export const PageContainer = ({
  children,
  title,
  actionButton,
  className,
  canGoBack,
  ...props
}: PageContainerProps) => {
  const navigate = useNavigate();

  return (
    <Flex
      className={className}
      maw={1512}
      w='100%'
      direction='column'
      gap={32}
      mx='auto'
      {...props}
    >
      <Flex align='center' justify='space-between' wrap='wrap' gap={16}>
        <Flex align='center' gap={16} w='100%'>
          {canGoBack && (
            <ActionIcon
              variant='outline'
              color='primary.5'
              size={38}
              className={classes.actionIcon}
              onClick={() => navigate(-1)}
            >
              <IconArrowLeft size={20} />
            </ActionIcon>
          )}

          <Title order={3}>{title}</Title>
        </Flex>

        {actionButton && actionButton}
      </Flex>

      {children}
    </Flex>
  );
};
